import React from 'react';
import Card from './Card';

export default function ProfileCard({ name, role, location, tone = 'bg-[#E8DCC7]' }) {
  return (
    <Card className="overflow-hidden">
      <div className={`h-24 ${tone}`} />
      <div className="p-3">
        <h3 className="text-sm font-semibold text-gray-900">{name}</h3>
        <p className="text-xs text-gray-500 mt-1">
          {role} • {location}
        </p>
        <div className="mt-3 flex items-center gap-3 text-[10px] font-semibold uppercase tracking-wide">
          <span className="text-[#C8A75B]">Certified</span>
          <span className="text-teal-600">Available</span>
        </div>
      </div>
    </Card>
  );
}

